var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGesture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 40,
    viewBox: "0 0 69 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1507 11.17V15.3383C13.1507 16.1295 12.2755 16.6073 11.61 16.1795L0.459243 9.01115C-0.153081 8.61751 -0.153081 7.72243 0.459242 7.32879L11.61 0.160457C12.2755 -0.267372 13.1507 0.21047 13.1507 1.00164V5.16997H22.1508C22.703 5.16997 23.1508 5.61768 23.1508 6.16997V10.17C23.1508 10.7223 22.703 11.17 22.1508 11.17H13.1507Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1508 5.16987L55.1508 1.00154C55.1508 0.210374 56.026 -0.267469 56.6915 0.160359L67.8423 7.3287C68.4546 7.72233 68.4546 8.61742 67.8423 9.01105L56.6915 16.1794C56.026 16.6072 55.1508 16.1294 55.1508 15.3382L55.1508 11.1699L46.1508 11.1699C45.5985 11.1699 45.1508 10.7222 45.1508 10.1699L45.1508 6.16988C45.1508 5.61759 45.5985 5.16987 46.1508 5.16987L55.1508 5.16987Z",
    fill: "white",
    fillOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1509,
    cy: 8,
    r: 7,
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2654 27.6052C26.5229 27.031 28.0976 27.4994 28.8524 28.7016C29.1848 29.231 30.0027 28.9955 30.0027 28.3704V23.7718V17.5484C30.0027 16.8017 30.5803 16 31.3018 16C32.0183 16 32.7419 16.7865 32.7873 17.5484L32.9266 24.0328C32.9286 24.0479 32.9306 24.0624 32.9328 24.0763C32.9629 24.271 33.0722 24.2297 33.0722 24.0328C33.0722 23.4284 33.5648 22.9389 34.1729 22.9389C35.3885 22.9389 36.3737 24.3064 36.3737 25.5144V24.689C36.3737 24.0846 36.8662 23.5951 37.4744 23.5951C38.6899 23.5951 39.6751 24.8014 39.6751 26.0094V25.3452C39.6751 24.7408 40.1677 24.2513 40.7758 24.2513C41.9914 24.2513 42.9765 25.2303 43 26.4384V31.8948C43 33.3686 42.4504 34.2806 42.0899 34.9145C42.0855 34.9223 42.0816 34.9289 42.0768 34.9365C41.9626 35.1209 40.3818 37.6896 40.3818 38.6883V39.3494C40.3818 39.7087 40.0905 40 39.7312 40H31.9506C31.5913 40 31.3001 39.7087 31.3001 39.3494V38.6883C31.3001 37.6728 28.2236 34.9983 28.1007 34.8918L28.0913 34.8834C27.5582 34.3981 26.9172 33.4398 26.6656 32.7614L25.0734 28.4674C24.9702 28.1892 25.0006 27.9733 25.0181 27.8945C25.0229 27.8726 25.0313 27.852 25.041 27.8319C25.0887 27.7332 25.1658 27.6507 25.2654 27.6052Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGesture);
export default __webpack_public_path__ + "static/media/gesture.ee7ae050c561236f54bea676fc19c43c.svg";
export { ForwardRef as ReactComponent };